import { AreaApi } from '@wiz-api/area-management'
import { PersonnelLocationApi } from '@wiz-api/dyw'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { AbpApplicationConfigurationApi } from '@wiz-api/abp-application'
import { map, forEach, get, find, concat, fromPairs, isEmpty, findIndex, filter } from 'lodash'

const areaApi = new AreaApi()
const personnelLocationApi = new PersonnelLocationApi()
const dataCategoryApi = new DataCategoryApi()
const abpApi = new AbpApplicationConfigurationApi()

/**
 * ** 复制自riskArea.js
 * ** 作业可视化（显示有正在进行作业的区域）
 */

/** ************************************************ 正在进行作业的区域列表 **************************************** */
// 正在进行作业的区域绘制实例列表
let riskAreaInstance = []
// 正在进行作业的区域列表
let riskAreaList = []
// 正在进行作业的区域图标列表
let areaIconList = []
// 风险等级与绘制区域颜色的映射
let riskLevelColor = {}
let cloudRender
let drawHandler
let clickAreaTimerOut = null
// 相关设置
const riskLevelMap =
  fromPairs(
    get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit-tongre"].config')?.riskLevelMap
  ) || []
let styleOptions = {
  type: 'riskArea',
  style: 'deafult',
}
let currentSceneId = ''
let currentOnlinePerson = 0

// 初始化数据
const initAreaData = () => {
  riskAreaInstance = []
  riskAreaList = []
  areaIconList = []
  riskLevelColor = {}
  drawHandler = null
  clickAreaTimerOut = null
  currentSceneId = ''
  currentOnlinePerson = 0
}

// 生成UUID
const getUUID = () => {
  const tempUrl = URL.createObjectURL(new Blob())
  const uuid = tempUrl.toString()
  URL.revokeObjectURL(tempUrl)
  return uuid.substring(uuid.lastIndexOf('/') + 1)
}

// 绘制标签
const drawMarker = async (player, areaDetail) => {
  if (!player.Native) return
  if (!areaDetail.isDisplayName) return
  const background = riskLevelMap[areaDetail.riskLevelName]
    ? riskLevelMap[areaDetail.riskLevelName]
    : 'sample'
  const index = findIndex(riskAreaInstance, ['areaId', areaDetail.id])
  const areaAabb = await player.Native.ElectoronicRail.getAabb(
    riskAreaInstance[index]?.areaObject?.data?.fenceObject
  )
  const pos = Aabb.faceCenter(areaAabb, 'Z')
  const singleOption = {
    id: getUUID(),
    pos,
    background,
    visible: true,
    nodeOffset: [0, -1000],
    text: `${areaDetail.name} ${currentOnlinePerson}人`,
    textColor: '#ffff00ff',
    hasTriangle: false,
    textFontSize:20,
    LodRange:[-1000000000,1000000000,0]
  }
  const picId = getUUID()
  const pictureOption = {
    id: picId,
    pos,
    backgroundUrl: `data://../apps/markers/${riskLevelMap[areaDetail.riskLevelName]}/left.png`,
    visible: true,
    nodeOffset: [-37, -48],
    imgSize: [49, 49],
  }
  // 文字
  const textRes = await cloudRender.Marker.createBySingleLine(singleOption)
  if (textRes.status) {
    const data = map(textRes.data, (item) => {
      return {
        id: item,
        areaId: areaDetail.id,
        type: 'single',
      }
    })
    areaIconList = concat(areaIconList, data)
  }
  // 图片
  const picRes = await cloudRender.Marker.createByPicture(pictureOption)
  if (picRes.status) {
    const data = map(picRes.data, (item) => {
      return {
        id: item,
        areaId: areaDetail.id,
        type: 'picture',
      }
    })
    areaIconList = concat(areaIconList, data)
  }
}

// 打开正在进行作业的区域详情
const openAreaDetail = (areaId) => {
  if (!areaId) {
    return
  }
  const name = riskAreaList.find((item) => { return item.id === areaId })?.name || '区域详情'
  const openEvent = new CustomEvent('openComponent', {
    detail: {
      toCom: {
        code: 'JobVisualization',
        origin: 'tag',
        name,
        originTagName: 'JobVisualization',
      },
      type: 'tags',
      props: {
        areaId,
        sceneId: currentSceneId,
      },
    },
  })
  window.dispatchEvent(openEvent)
}

// 获取当前区域人员数量
const getOnlinePerson = async (sceneId) => {
  await personnelLocationApi.syncChronousPosition()
  const [errPerson, resPerson] = await personnelLocationApi.getArea({
    modelId: sceneId,
  })
  if (!errPerson && Array.isArray(resPerson) && resPerson.length > 0) {
    if (resPerson[0].positions) {
      currentOnlinePerson = resPerson[0].positions.length
    }
  }
}
// 获取作业风险区域
// 获取正在进行作业的区域列表
const getAreaList = async (sceneId) => {
  getOnlinePerson(sceneId)
  // const [err, res] = await areaApi.getList({
  //   modelId: sceneId,
  //   skipCount: 0,
  //   maxResultCount: 1000,
  // })
  // if (!err && res) {
  //   return res.items
  // }
  const [err, res] = await personnelLocationApi.getWorkingAreaList({
    modelId: sceneId,
    skipCount: 0,
    maxResultCount: 1000,
  }).catch((e) => { return e })
  if (!err && res) {
    return res
  }
  return []
}

// New：获取风险等级列表（作业区域）
// 作业区域四个风险等级颜色，分别是：红色（#ff3a3080）、橙色（#ff950280）、黄色（#f8b20080）、蓝色（#0082f780）。
const handleDicDataByCode = () => {
  riskAreaList.forEach((item) => {
    console.log('item.riskLevelName', item.riskLevelName)
    // 默认值蓝色
    let color = '#ff3a3080'
    if (item.riskLevelName === '蓝色') {
      color = '#0082f780'
    }
    if (item.riskLevelName === '红色') {
      color = '#ff3a3080'
    }
    if (item.riskLevelName === '橙色') {
      color = '#ff950280'
    }
    if (item.riskLevelName === '黄色') {
      color = '#f8b20080'
    }
    riskLevelColor[item.id] = color
  })
}

// Old：获取风险等级列表（应该是两票的等级）
const getDicDataByCode = async () => {
  const [configError, abpConfigList] = await abpApi.get()
  if (!configError && !isEmpty(abpConfigList)) {
    const [statusError, statusRes] = await dataCategoryApi.getByCode({
      code: abpConfigList.setting.values['AreaManagement.DataCategory.RiskLevel'],
    })
    if (!statusError) {
      forEach(statusRes?.dataItems, (item) => {
        riskLevelColor[item.id] = item.code
      })
    }
  }
}

// 绘制正在进行作业的区域
// 作业区域四个风险等级颜色，分别是：红色（#ff3a3080）、橙色（#ff950280）、黄色（#f8b20080）、蓝色（#0082f780）。
const drawRiskArea = async (player, areaDetail, riskLevelId, riskLevelName) => {
  styleOptions = {
    type: 'riskArea',
    style: 'deafult',
  }
  if (!player.Native) return
  let color = ''
  if (riskLevelName === '蓝色') {
    color = '#0082f780'
  }
  if (riskLevelName === '红色') {
    color = '#ff3a3080'
  }
  if (riskLevelName === '橙色') {
    color = '#ff950280'
  }
  if (riskLevelName === '黄色') {
    color = '#f8b20080'
  }
  // if (!isEmpty(riskLevelColor[riskLevelId])) {
  //   styleOptions.style = riskLevelColor[riskLevelId]
  // }
  if (!isEmpty(color)) {
    styleOptions.style = color
  }
  const pos = map(JSON.parse(areaDetail.coordinate), (item) => {
    return [item.x, item.y, item.z]
  })
  const baseOptions = {
    name: 'newArea',
    pos,
    height: areaDetail.height || 2.0,
    editMode: false,
  }
  const markerOptions = {
    showMarker: true,
    options: {
      background: color,
      // background: 'sample',
      text: `${areaDetail.name} ${areaDetail.realTimePersonCount}人`,
      markPosType: 4,
      nodeOffset: [0, -100],
      textFontSize:16,
      id: areaDetail.id,
      // LodRange:[-1000000000,1000000000,0]
    },
  }
  const areaObject = await cloudRender.ElectoronicRail.createByPosition(baseOptions, styleOptions, markerOptions)
  // 缓存围栏绑定的数据id
  riskAreaInstance.push({ areaId: areaDetail.id, areaObject })
  drawMarker(player, areaDetail)
}

// 标签事件
const markerClick = async(e) => {
  if (e.type === 1 && !isEmpty(e.markerId)) {
    riskAreaList.map(async item=>{
      if(item.id == e.markerId){
        openAreaDetail(item.id)
      }
    })
  }
}

// 正在进行作业的区域点击事件
const eventSelected = (e) => {
  if (e.fence) {
    const areaInfo = find(riskAreaInstance, ['areaObject.data.fenceObject', e.fence])
    // 不存在选中正在进行作业的区域
    if (!areaInfo) {
      return
    }
    openAreaDetail(get(areaInfo, 'areaId'))
  }
}

// 创建正在进行作业的区域
const create = async (player, sourceId, propCloudRender) => {
  if (!player.Native) {
    return
  }
  // 初始化数据
  initAreaData()
  // 设置当前场景id
  currentSceneId = sourceId
  cloudRender = propCloudRender
  // 生成正在进行作业的区域
  drawHandler = new Promise(async (resolve) => {
    // 获取正在进行作业的区域列表数据
    riskAreaList = await getAreaList(sourceId)
    // riskAreaList = [
    //   {
    //     seqNo: 0,
    //     id: '8fbc7324-aaf3-8ec7-7bc3-3a147acdbb05',
    //     modelId: 'd7885d2f-4487-7665-c248-3a1326f6064f',
    //     mapId: null,
    //     mapName: null,
    //     code: '100',
    //     name: '保安',
    //     areaTypeId: '7ff562ed-cb37-d818-436a-3a1388b15670',
    //     areaTypeName: '个人责任区域',
    //     height: 1,
    //     leaderId: null,
    //     leaderName: null,
    //     playerVisualAngleJson: '',
    //     coordinate: '[{"seqNo":0,"x":"26.604683","y":"-76.369843","z":"-0.480000"},{"seqNo":1,"x":"27.219719","y":"-47.580433","z":"-0.480000"},{"seqNo":2,"x":"-4.513515","y":"-49.651009","z":"-0.300000"},{"seqNo":3,"x":"-4.782369","y":"-79.926445","z":"-0.300000"},{"seqNo":4,"x":"-4.782369","y":"-79.926445","z":"-0.300000"},{"seqNo":5,"x":"-4.322131","y":"-82.150620","z":"-0.300000"},{"seqNo":6,"x":"-4.322131","y":"-82.150620","z":"-0.300000"},{"seqNo":7,"x":"-3.826439","y":"-81.768402","z":"-0.300000"},{"seqNo":8,"x":"-3.826439","y":"-81.768402","z":"-0.300000"}]',
    //     riskLevelId: '50e2f0fc-76d4-3ca6-0ef3-3a1388b15670',
    //     riskLevelName: '蓝色',
    //     isDisplayName: false,
    //     fenceId: 'b4f0353a-499a-64e6-14ee-3a147ad5483a',
    //     thirdFenceId: null,
    //     thirdAreaId: null,
    //     alarmCount: 0,
    //     realTimePersonCount: 0,
    //     isDrawed: true,
    //     areaGroupIds: [],
    //     areaGroupList: [],
    //     parentId: null,
    //     children: null
    //   },
    // ]
    if (riskAreaList.length < 1) return
    riskAreaList = filter(riskAreaList, 'isDrawed')
    // 获取风险等级跟颜色对应
    // await getDicDataByCode()
    await Promise.all(
      map(riskAreaList, (item) => {
        // 绘制正在进行作业的区域
        return drawRiskArea(player, item, item.riskLevelId, item.riskLevelName)
      })
    )
    resolve()
  })
  cloudRender.Dispatch.on('Marker', markerClick)
  // 监听正在进行作业的区域点击事件
  player.Native.ElectoronicRail.EventSelected.connect(eventSelected)
}
// 销毁正在进行作业的区域
const destroy = async (player) => {
  if (!player.Native) {
    return
  }
  await drawHandler
  if (!get(cloudRender, 'Marker')) return
  // 销毁图标
  cloudRender.Marker.destroyMarker(map(areaIconList, 'id'))
  // 销毁正在进行作业的区域绘制
  cloudRender.ElectoronicRail.destroy(map(riskAreaInstance, 'areaObject.data.id'))
  // 取消标签的事件监听
  cloudRender.Dispatch.off('Marker', markerClick)
  // 取消正在进行作业的区域事件监听
  player.Native.ElectoronicRail.EventSelected.disconnect(eventSelected)
}

// 切换标签围栏显示隐藏
const toggleDisplay = async (player, type) => {
  await drawHandler
  // 设置围栏的显隐
  forEach(riskAreaInstance, async (item) => {
    await player.Native.ElectoronicRail.setVisible(item.areaObject?.data?.fenceObject, type)
  })
  cloudRender.Marker.updateBySingleLine(
    map(
      filter(areaIconList, (item) => {
        return item.type === 'single'
      }),
      (i) => {
        return {
          id: i.id,
          visible: type,
        }
      }
    )
  )
  cloudRender.Marker.updateByPicture(
    map(
      filter(areaIconList, (item) => {
        return item.type === 'picture'
      }),
      (i) => {
        return {
          id: i.id,
          visible: type,
        }
      }
    )
  )
}

// 隐藏正在进行作业的区域及其标签
const hidden = async (player) => {
  await toggleDisplay(player, false)
}

// 重新显示正在进行作业的区域及其标签
const display = async (player) => {
  await toggleDisplay(player, true)
}

// 移动视角到正在进行作业的区域
const moveToArea = async (areaId) => {
  // 没有设置视角，那么默认移到区域的视角
  const area = find(riskAreaInstance, ['areaId', areaId])
  if (area) {
    const aabb = await player.Native.ElectoronicRail.getAabb(
      get(area, 'areaObject.data.fenceObject', [])
    )
    await cloudRender.Camera.moveCamera('Aabb', [aabb[0], aabb[1]])
  }
}
export default { create, destroy, hidden, display, moveToArea }
